import { ProductOriginal } from "app/pages/Listing/Product/ProductOriginal";

export default props => <ProductOriginal {...props} />;
